<template>
    <b-container >
       <div class="row mb-5 wrapper-step-content" >
            <div class="col-12 step-content">
               <b-row class="row-navbar-padding" />
                <b-col cols="12" class="text-center mt-4 mb-5  simple-text" tabindex="0">
                    {{getMessage(24, 'rapidexperiment-sub')}}   
                </b-col>
            </div>  
            <b-col cols="12"> 
                <b-row  class="mb-5 button-row-cover" >
                      <b-col cols="12"  class="button-next">
                        <b-button block variant="primary" size="lg"  type="submit" @click="$router.push({name : 'home' })">
                             Next
                        </b-button>
                     </b-col>            
                </b-row> 
            </b-col>
           
        </div>
 
    </b-container>

</template>

<script>
    export default {
        name: "GoBroadToGoNarrow13Other",
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"
    .container
        margin-top -5px
    .step-content
        min-height calc(100vh - 160px)
        overflow-wrap: anywhere;

    .wrapper-step-content
        background-color white
        min-height calc(100vh - 142px)
        border-radius 0 0 25px 25px
    
    .row-navbar-padding
        padding-top 107px

    .button-row
        padding-top 50px
        padding-bottom 28px

    .next-arrow
        margin-left 5px

    .step-content-cover
        min-height calc(100vh - 72px)
        overflow-wrap: anywhere;

    .button-row-cover
        margin-top -20px
        padding-bottom 28px
   
    +for_breakpoint(xs) 
       .font-size
            .row-navbar-padding
                padding-top 125px !important

    +for_breakpoint(md) 
        .wrapper-step-content
            border-radius 27px
            box-shadow(0px 4px 5px 0px #BDD5E580)
            margin-top 75px
            min-height calc(100vh - 217px)
            padding-bottom 50px
        .row-navbar-padding
            padding-top 40px
        .button-next
           padding-right: 15px !important
    +for_breakpoint(sm) 
       .wrapper-step-content
            background-color white
            min-height calc(100vh - 142px)
            box-shadow(0px 4px 5px 0px #BDD5E580)
            margin-top 15px
            margin-left 2px
            margin-right 2px
            border-radius 27px

    +for_breakpoint(lg) 
        .wrapper-step-content
            margin-top 15px
</style>